// extracted by mini-css-extract-plugin
export default {"normal":"normal-ZDR5Yz","feedback":"feedback-xsxWIh","chineseFeedback":"chineseFeedback-tXS7Bk","feedback-icon":"feedback-icon-wYoF8i"};